import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const FeatureTableSessionCacheContext = /*#__PURE__*/createContext({
  isInitialized: false,
  isUpgradePoint: false,
  onPurchaseMotionButtonClick: undefined,
  productApiNames: [],
  purchaseMotionLocation: 'MERCH_CARD',
  revenueAttributionUniqueId: undefined,
  screen: undefined,
  sessionCacheKey: '',
  skuCategoryName: 'CRM_SUITE',
  term: undefined,
  displayOptions: {
    showPrice: true,
    showPurchaseMotion: true
  }
});
export const FeatureTableSessionCacheProvider = ({
  children,
  isUpgradePoint,
  onPurchaseMotionButtonClick,
  productApiNames,
  purchaseMotionLocation,
  revenueAttributionUniqueId,
  screen,
  skuCategoryName,
  term,
  displayOptions = {
    showPrice: true,
    showPurchaseMotion: true
  }
}) => {
  const sessionCacheKey = productApiNames.join('-');
  return /*#__PURE__*/_jsx(FeatureTableSessionCacheContext.Provider, {
    value: {
      isInitialized: true,
      isUpgradePoint,
      onPurchaseMotionButtonClick,
      productApiNames,
      purchaseMotionLocation,
      revenueAttributionUniqueId,
      screen,
      sessionCacheKey,
      skuCategoryName,
      term,
      displayOptions
    },
    children: children
  });
};
export const useFeatureTableSessionCache = () => {
  const featureTableSessionCacheContext = useContext(FeatureTableSessionCacheContext);
  let errorMessage;
  if (!featureTableSessionCacheContext.isInitialized) {
    errorMessage = 'useFeatureTableSessionCache must be used within a FeatureTableSessionCacheProvider. Check to see if the component is wrapped the required Provider';
  } else if (featureTableSessionCacheContext.sessionCacheKey === '') {
    errorMessage = 'An error occured while trying to set the session key. Please check to see if the productApiNames are available';
  }
  if (errorMessage) {
    throw new Error(errorMessage);
  }
  return featureTableSessionCacheContext;
};